module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n ';
 _.each(getListColumns(), function(column, key) { 
__p+='\n\n 	';
 if (key === 'status') { 
__p+='\n 	<td class="column--status is-'+
((__t=( getConditionalStr(obj.online, 'online', 'offline')))==null?'':__t)+
' '+
((__t=( getConditionalStr(obj.error, 'has-error', '')))==null?'':__t)+
' "></td>\n\n 	';
 } else { 
__p+='\n 	<td class="'+
((__t=( getHideClasses(key) ))==null?'':__t)+
' ';
 if (key === '_actions') { 
__p+='row-actions';
 } 
__p+='">\n\n 		';
 if (key === '_bulk') { 
__p+='\n 			<input type=\'checkbox\' class="js-bulk-select" ';
 if (obj._bulk) { 
__p+='checked';
 } 
__p+=' />\n 	 	';
 } else if (key === '_actions') { 
__p+='\n\n			';
 _.each(column.options, function(option, optionKey) { 
__p+='\n				<span class="m-icon-btn icon-'+
((__t=( optionKey ))==null?'':__t)+
' js-'+
((__t=( option.action ))==null?'':__t)+
'"></span>\n			';
 }) 
__p+='\n\n 		';
 } else { 
__p+='\n 			<div title="'+
((__t=( getColumnField(key) ))==null?'':__t)+
'"><span >'+
((__t=( getColumnField(key) ))==null?'':__t)+
'</span></div>\n		';
 } 
__p+='\n\n\n 	</td>\n 	';
 } 
__p+='\n';
 }) 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/list/templates/item.html
// module id = 440
// module chunks = 0